import type { TurnEntry } from "../../api/calls";

/**
 * Collect the distinct pipeline-model values per role across a call's turns.
 * The per-turn `models` map is written by the worker (e.g. { stt, llm, tts });
 * its shape is not guaranteed, so we tolerate arbitrary keys and keep only
 * scalar (string/number) values — objects and null are skipped. Values are
 * deduped and sorted for stable display.
 */
export function distinctModels(turns: TurnEntry[]): Record<string, string[]> {
  const acc: Record<string, Set<string>> = {};
  for (const t of turns) {
    const models = t.models ?? {};
    for (const [key, raw] of Object.entries(models)) {
      if (raw === null || typeof raw === "object") continue;
      (acc[key] ??= new Set<string>()).add(String(raw));
    }
  }
  const out: Record<string, string[]> = {};
  for (const [key, set] of Object.entries(acc)) {
    out[key] = [...set].sort();
  }
  return out;
}
